import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TMonthlyFeeStore,
	TFeeClassResponseData,
	TMonthlyFeeResponseData,
	TMonthlyFeeListResponseData,
	TEMerchantsResponseData,
} from './types';

export const getMonthlyFeeState = (state: TStoreState): TMonthlyFeeStore => state.monthlyFee;

export const getMonthlyFee = createSelector(
	[getMonthlyFeeState],
	(monthlyFee: TMonthlyFeeStore) => monthlyFee,
);

// ==========================================:

export const getMonthlyFees = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): TMonthlyFeeResponseData => monthlyFee.monthlyFee,
);

// ==========================================:

export const getMonthlyFeesLoader = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): boolean => monthlyFee.monthlyFeeLoader,
);

// ==========================================:

export const getEMerchant = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): TEMerchantsResponseData => monthlyFee.eMerchant,
);

// ==========================================:

export const getEMerchantLoader = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): boolean => monthlyFee.eMerchantLoader,
);

// ==========================================:

export const getFeeClasses = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): TFeeClassResponseData => monthlyFee.feeClasses,
);

// ==========================================:

export const getFeeClassesLoader = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): boolean => monthlyFee.feeClassesLoader,
);

// ==========================================:

export const getMonthlyFeeList = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): TMonthlyFeeListResponseData => monthlyFee.monthlyFeeList,
);

// ==========================================:

export const getMonthlyFeeListLoader = createSelector(
	[getMonthlyFee],
	(monthlyFee: TMonthlyFeeStore): boolean => monthlyFee.monthlyFeeListLoader,
);
